import * as React from "react";
import { useMemo, useState } from "react";
import InputSetupWizardStepsContext from "components/inputs/InputSetupWizard/contexts/InputSetupWizardStepsContext";
const InputSetupWizardStepsProvider = ({ children = null }) => {
  const [stepsData, setStepsData] = useState({});
  const value = useMemo(
    () => ({
      stepsData,
      setStepsData
    }),
    [stepsData]
  );
  return /* @__PURE__ */ React.createElement(InputSetupWizardStepsContext.Provider, { value }, children);
};
export default InputSetupWizardStepsProvider;
